/**
 * POPULATION-DELETE.MODAL
 */
import ModalConfirm from "@/components/modal-confirm"
import { t } from "i18next"
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import populationStore from "@/entities/population/model/population.store"
import preventionActionStore from "@/entities/prevention-action/model/prevention-action.store"

interface Props {
  onClose: () => void
}

export default function PopulationDeleteModal(props: Props) {
  const dispatch = useAppDispatch()

  //Selectors
  const population = useAppSelector(populationStore.selectors.draft)

  //Remove site
  async function handleDelete() {
    const response = await dispatch(populationStore.thunks.removeEntity(population.id))
    if (response?.type !== "population/remove/rejected") {
      //Les mesures RPS qui n'avaient que cette fonction sont supprimees avec elle
      dispatch(preventionActionStore.thunks.fetchAndSet())
      props.onClose()
    }
  }

  return (
    <ModalConfirm
      onNo={() => props.onClose()}
      onYes={() => handleDelete()}
      textBold={t("utils_next_ask")}
      text={`Vous êtes sur le point de supprimer la fonction « ${population.name} ».`}
    />
  )
}
